
import Vue from 'vue';
import { mapState } from 'vuex';
import ReferralTable from './ReferralTable.vue';
import BaseProgress from '@/components/base/BaseProgress.vue';
import {
	getAcceptedReferralDismissed,
	setAcceptedReferralDismissed,
} from '@/utils/localStorage';
import {
	DAILY_FREE_RUNNIT_TOKENS_BASE,
	DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL,
	RUNNIT_BONUS_NUM_REFERRALS,
} from '@run-diffusion/shared';
import { MyBalanceMixin } from '@/mixins';
import ClipboardCopy from '@/components/ClipboardCopy.vue';
import { analytics, EVENTS } from '@/services/analytics';

export default Vue.extend({
	name: 'ReferEarnSection',
	mixins: [
		MyBalanceMixin,
	],
	components: {
		ClipboardCopy,
		ReferralTable,
		BaseProgress,
	},
	data() {
		return {
			DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL,
			DAILY_FREE_RUNNIT_TOKENS_BASE,
			isReferralDismissed: getAcceptedReferralDismissed(),
		};
	},
	computed: {
		...mapState([
			'user',
		]),
		dailyTokens (): number {
			if (
				!this.userBalanceAccountRunnitTokensData.dailyFreeRunnitTokensAllotmentIfValid ||
				!this.userBalanceAccountRunnitTokensData.isFreemiumPassportValid
			) return 0;
			return this.userBalanceAccountRunnitTokensData.dailyFreeRunnitTokensAllotmentIfValid;
		},
		maxBonusTokens(): number {
			return RUNNIT_BONUS_NUM_REFERRALS * DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL;
		},
		dailyTokensLimit() {
			// Calculate the max possible daily tokens
			return DAILY_FREE_RUNNIT_TOKENS_BASE + this.maxBonusTokens;
		},
		hasAcceptedReferral(): boolean {
			return !!this.user.freemiumInfo.acceptedReferralCode;
		},
		effectiveReferralCount(): number {
			let result: number = this.user.freemiumInfo.referralUserInfos
				? Object.keys(this.user.freemiumInfo.referralUserInfos).length
				: 0;

			if (this.hasAcceptedReferral) {
				result += 1;
			}

			return result;
		},
		maxReferrals(): number {
			return RUNNIT_BONUS_NUM_REFERRALS;
		},

		referralCode(): string {
			return this.user?.freemiumInfo?.referralCode || '';
		},

		referralLink(): string {
			if (!this.referralCode) return '';

			// Create referral link with the proper domain and referral code
			return `${window.location.origin}/?referralCode=${this.referralCode}`;
		},
	},
	methods: {
		dismissReferralNotification() {
			this.isReferralDismissed = true;
			setAcceptedReferralDismissed();
		},
		onReferralLinkCopyClick () {
			analytics.track(EVENTS.REFERRAL_LINK_COPIED, {
				has_link: !!this.referralLink,
			});
		},
	},
});
